<template>
  <div id="app">
    <AppLayout v-if="!isLeasing">
      <router-view />
    </AppLayout>
    <BrandedAppLayout v-else>
      <router-view />
    </BrandedAppLayout>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import network from "./utils/network";
import { newLogger } from "@/utils/util";
import BrandedAppLayout from "./layouts/BrandedAppLayout.vue";

const logger = newLogger("App.VUE");
const TODO_POLL_SECOND = 60000;

export default {
  title: "af:page.default.title",
  components: {
    AppLayout: () => import("@/layouts/AppLayout.vue"),
    BrandedAppLayout,
  },
  data() {
    return {
      todoCountPoll: null,
      loaded: false,
    };
  },
  async created() {
    network.configure(this.$store, this.$router, this.$route);

    await this.fetchPublicTokens();
    await this.fetchInternalTokens();
    await this.fetchAutoloadConfigs();
    await this.fetchHasActivePurchase();
    await this.fetchTodoCount();

    this.todoCountPoll = window.setInterval(() => {
      this.fetchTodoCount();
    }, TODO_POLL_SECOND);
  },
  beforeDestroy() {
    window.clearInterval(this.todoCountPoll);
  },
  computed: {
    ...mapGetters({
      loggedIn: "session/isReady",
    }),
    isLeasing() {
      return /^\/leasing.*/i.test(this.$route.path);
    },
  },
  methods: {
    ...mapActions({
      fetchPublicTokensByLanguage: "i18n/fetchTokensByLanguage",
      fetchInternalTokensByLanguage: "i18n/fetchInternalTokensByLanguage",
      loadTokensByLanguage: "i18n/fetchInternalTokensByLanguage",
      fetchAutoloadConfigsFromStore: "config/fetchAutoloadConfigs",
    }),
    async fetchPublicTokens() {
      try {
        await this.fetchPublicTokensByLanguage("hu");
      } catch (ex) {
        logger.error(ex);
        logger.error("Public Token fetch failed!");
        setTimeout(() => this.fetchPublicTokens(), 1000);
      }
    },
    async fetchTodoCount() {
      if (this.loggedIn) {
        await this.$store.dispatch("myTodo/fetchCount");
      }
    },
    async fetchHasActivePurchase() {
      if (this.loggedIn) {
        await this.$store.dispatch("purchase/hasActivePurchase");
      }
    },
    async fetchInternalTokens() {
      if (this.$store.getters["session/isReady"]) {
        try {
          await this.fetchInternalTokensByLanguage("hu");
        } catch (ex) {
          logger.error(ex);
          logger.error("Internal Token fetch failed!");
          this.retryInternalTokens();
        }
      } else {
        this.retryInternalTokens();
      }
    },
    retryInternalTokens() {
      setTimeout(() => this.fetchInternalTokens(), 1000);
    },
    async fetchAutoloadConfigs() {
      try {
        await this.fetchAutoloadConfigsFromStore();
      } catch (ex) {
        logger.error(ex);
        logger.error("Autoload config fetch failed!");
        setTimeout(() => this.fetchAutoloadConfigs(), 1000);
      }
    },
  },
  mounted() {
    let cookiePreference =
      localStorage.getItem("allowAnalyticsCookies") || "false";
    if (cookiePreference === "true") {
      this.$gtag.query("consent", "default", {
        analytics_storage: "granted",
      });
    } else {
      this.$gtag.query("consent", "default", {
        analytics_storage: "denied",
      });
    }
    this.loaded = true;
  },
  updated() {
    let cookiePreference =
      localStorage.getItem("allowAnalyticsCookies") || "false";
    if (cookiePreference === "true") {
      this.$gtag.query("consent", "update", {
        analytics_storage: "granted",
      });
    } else {
      this.$gtag.query("consent", "update", {
        analytics_storage: "denied",
      });
    }
  },
};
</script>
